export default __webpack_public_path__ + "static/media/rpl7.d10789a2.jpg";